// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iEYV7zbCLH4li_jaZBnJ{flex-direction:column;gap:12px;display:flex}.S8WOoSRY2sL2arOA0zi7{background:var(--background-brand-subtle-primary);white-space:pre-wrap;word-break:break-word;border-radius:16px;align-self:flex-end;margin-left:24px;padding:12px 16px}.ILsD1WVu1ovVuRgvE0xE{background:var(--red-a-15)}.TNzrziwiC3QyGM4zqXJy{justify-content:space-between;align-items:center;margin-left:24px;display:flex}.Mh81pL5jsMiewf5wQarh{white-space:pre-wrap;word-break:break-word;flex-direction:column;gap:16px;margin-right:24px;display:flex}.TI3BnAUAS8rjkwW2PZzQ{flex-direction:column;gap:8px;display:flex}.vVDnG097pXIhIXpVLmXT{width:-webkit-fit-content;width:fit-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageGroup": `iEYV7zbCLH4li_jaZBnJ`,
	"messageUser": `S8WOoSRY2sL2arOA0zi7`,
	"messageUserError": `ILsD1WVu1ovVuRgvE0xE`,
	"errorRow": `TNzrziwiC3QyGM4zqXJy`,
	"messageAssistant": `Mh81pL5jsMiewf5wQarh`,
	"optionsWrap": `TI3BnAUAS8rjkwW2PZzQ`,
	"optionBtn": `vVDnG097pXIhIXpVLmXT`
};
export default ___CSS_LOADER_EXPORT___;
